import React from 'react'
import closeIcon from '../../../../../assets/images/closeIconGray.svg';

import './commentItem.css';

export const CommentItem = (props) => {
    return (
        props.content
            ? <div className={props.isShowCommentItem ? "comment-item-container container d-flex flex-row align-items-center justify-content-start no-padding" : "hide-element"}>
                <div onClick={props.editComment} className="col-11">
                    <p className="comment-content">{props.content}</p>
                </div>
                <div className="col-1 d-flex flex-column align-items-center justify-content-start">
                    <img alt="" onClick={props.deleteComment} className="close-icon" src={closeIcon} />
                </div>
            </div>
            : ''
    )
}


// WEBPACK FOOTER //
// ./src/screens/Question/components/QuestionItem/CommentItem/CommentItem.js